import * as React from 'react';
import { RenderHtml } from '../../helpers/render-html';
import { withTranslator } from '../../helpers/shared';
import { TranslateFn } from '@wix/answers-lib';

export class ForgotDomain extends React.PureComponent<withTranslator> {
	compTranslate: TranslateFn = (key, params) => this.props.t(`marketing-site.signup-form.forgot-domain.${key}`, params);

	render () {
		const {compTranslate} = this;

		return (
			<div className='new-forgot-domain-container'>
				<header>
					<h1>{compTranslate('title')}</h1>
				</header>
				<main className='forgot-domain-body'>
					<p><RenderHtml html={compTranslate('send-email-new')}/></p>
					<p>{compTranslate('description')}</p>
				</main>
				<footer>
					<a className='hollow-btn' href='/login'>{compTranslate('go-back')}</a>
				</footer>
			</div>
		);
	}
}
